module.exports = __webpack_public_path__ + "img/ccid-red.d175a28b.jpg";